export default __webpack_public_path__ + "static/img71h-c0d777925e54df1aa06a7617e0035c49.jpg";